var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5014 2.61385L14.1557 7.70544C14.3018 8.15487 14.7206 8.45916 15.1931 8.45916L20.5468 8.45916C21.1191 8.45916 21.357 9.19151 20.894 9.5279L16.5628 12.6747C16.1805 12.9524 16.0206 13.4448 16.1666 13.8942L17.821 18.9858C17.9978 19.5301 17.3748 19.9827 16.9118 19.6463L12.5807 16.4996C12.1983 16.2218 11.6807 16.2218 11.2984 16.4996L6.96719 19.6463C6.50418 19.9827 5.88121 19.5301 6.05806 18.9858L7.71242 13.8942C7.85845 13.4448 7.69847 12.9524 7.31617 12.6747L2.985 9.5279C2.52199 9.19151 2.75995 8.45916 3.33226 8.45916L8.68587 8.45916C9.15843 8.45916 9.57725 8.15487 9.72327 7.70544L11.3776 2.61385C11.5545 2.06955 12.3245 2.06955 12.5014 2.61385Z",
    fill: "url(#paint0_linear_33_397)",
    stroke: "#B068EE",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_397",
    x1: 23.7106,
    y1: 11.8466,
    x2: 0.168457,
    y2: 11.8466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B068EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B068EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalf);
export default __webpack_public_path__ + "static/media/star-half.d6b7737e4915a841b9ffbb08c3c61953.svg";
export { ForwardRef as ReactComponent };